/**
 * Wraps every /admin/* route (dashboard, approvals, users + users/[id],
 * notices, polls, issues, vendors, create-notice, create-poll,
 * create-vendor) with the shared AdminGate — a resident who guesses or
 * bookmarks an admin URL now sees the same branded "Admins only" EmptyState
 * everywhere instead of only on /admin itself. See audit 05 P0-3.
 */
import { Slot } from 'expo-router';
import React from 'react';

import { AdminGate } from '@/features/account-admin/AdminGate';

export default function AdminLayout() {
  return (
    <AdminGate>
      <Slot />
    </AdminGate>
  );
}
